import React, { useEffect } from "react";
import { HeroComponent } from './HeroComponent';
import { useTranslation } from 'react-i18next';
import { useSurvey } from "../hooks/useSurveyContext";
import { useParams } from "react-router-dom";

export const UnsubscribeConfirmedComponent = () => {
  const {t, i18n} = useTranslation()
  const { setLanguage } = useSurvey()
  const { languagecode } = useParams()
  useEffect(()=>{
    setLanguage(languagecode)
  },[languagecode])

  return(
    <>
    <div className='container grey'>
        <HeroComponent />

        <div className='container-fluid white my-3' >
            <div className='row'>
                <div className='col p-6'>
                    <h2>{t("Unsubscribe/ConfirmedText")}</h2>
                </div>
            </div>
        </div>
    </div>

</>
  )

}